import io from 'socket.io-client';
import EventEmmiter from '../native-interact/EventEmmiter';

// export const remoteUrl = 'http://city.parking24.cn:6060';
export const remoteUrl = 'https://city.parking24.cn';
// export const remoteUrl = 'http://192.168.10.61:6060';

export default class Socket extends EventEmmiter {
  constructor(url) {
    super();
    this.socket = null;
    this.url = url || remoteUrl;
  }

  get instance() {
    return this.socket;
  }

  connect() {
    return new Promise((resolve) => {
      this.socket = io.connect(this.url);
      this.socket.on('connect', () => {
        resolve(this.socket);
      });
      this.socket.on('disconnect', () => {
        this.emmit('disconnect');
      });
      this.socket.on('error', (error) => {
        console.log(error);
        this.emmit('error', error);
      });
      this.socket.on('message', (data) => {
        this.emmit('message', data);
      });
    });
  }

  emitCommandResponse(data) {
    if (this.socket) {
      this.socket.emit('post', Object.assign({
        type: 'command result'
      }, data));
    }
  }

  close() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }
}

export const socket = new Socket();
